import {
  INDIVIDU_INICIALITZAR,
  INDIVIDU_INTRODUCCIO_MOSTRAR_ERRORS,
  INDIVIDU_INTRODUCCIO_DESCARTAR_CANVIS
} from "../../../actions/actionTypes";

const ESTAT_INICIAL = false;

const mostrarErrors = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INDIVIDU_INICIALITZAR:
    case INDIVIDU_INTRODUCCIO_DESCARTAR_CANVIS:
      return ESTAT_INICIAL;

    case INDIVIDU_INTRODUCCIO_MOSTRAR_ERRORS:
      return true;

    default:
      return state;
  }
};

export default mostrarErrors;
